import React, { Component } from "react";
import { connect } from "react-redux";
import { professionalAction } from "../../_actions";
import {
  Input,
  message,
  PageHeader,
  Switch,
  Table,
  Button,
  Row,
  Col,
  Modal,
  Space,
  Radio,
  Tooltip,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { LanguageContext } from "../../context/LanguageContext";
import { adminService } from "../../_services/admin.service";
import { Select } from "antd";
import { ViewFormModel } from "../ProfessionalForm/ViewForm/ViewFormModel";
import * as XLSX from "xlsx-js-style";
import moment from "moment";
import _ from "lodash";
import domtoimage from "dom-to-image-more";
import { superAdminService } from "../../_services/superadmin.service";
import html2canvas from "html2canvas";
import { ImageView } from "../image/imageView";
import { ImageViewOnly } from "../image/onlyImageVIew";
const { Option } = Select;
const CCTNS_MISSING_IMAGE_URL =
  "https://cctns-missing-persons.s3.ap-south-1.amazonaws.com/";

class CctnsMissingList extends Component {
  static contextType = LanguageContext;
  state = {
    data: [],
    cityId: [],
    loading: false,
    searchText: "",
    pagination: {
      current: 1,
      pageSize: 10,
    },
    is_update: false,
    setCriminalViewModel: false,
    update_value: null,
    selectedGender: undefined,
    updateLoading: false,
    states: [],
    cities: [],
    selectedGenders: {},
    bulkUpdateLoading: false,
    type: "pending",
  };

  handleGenderChange = (id, gender) => {
    this.setState((prevState) => ({
      selectedGenders: {
        ...prevState.selectedGenders,
        [id]: gender,
      },
    }));
  };
  handleBulkGenderUpdate = () => {
    const { selectedGenders } = this.state;

    const data = Object.keys(selectedGenders).map((id) => ({
      id,
      gender: selectedGenders[id],
    }));

    if (data.length === 0) {
      message.warning("Please select gender for at least one record");
      return;
    }

    this.setState({ bulkUpdateLoading: true });

    superAdminService
      .CctnsMissingUpdate({ data })
      .then((res) => {
        message.success(res?.message || "Gender updated successfully");

        this.setState({
          selectedGenders: {},
          bulkUpdateLoading: false,
        });

        this.getCctnsMissingList();
      })
      .catch(() => {
        message.error("Failed to update gender");

        this.setState({
          bulkUpdateLoading: false,
        });
      });
  };
  getCountry = () => {
    this.setState({
      loading: true,
    });
    professionalAction.getCountry().then((res) => {
      this.setState({
        states: res.pc_countrystates,
        loading: false,
      });
    });
  };

  getStatesWiseCityData = (id) => {
    professionalAction.getStatesWiseCityData(id).then((res) => {
      this.setState({
        cities: res.pc_citiesData,
      });
    });
  };
  componentDidMount() {
    this.props.dispatch(professionalAction.getAllMaster());
    this.props.dispatch(professionalAction.getCity());

    this.props.dispatch(professionalAction.getDharm());
    this.props.dispatch(professionalAction.getKalam());
    this.props.dispatch(professionalAction.getKayda());
    this.props.dispatch(professionalAction.getCrimeType());
    this.props.dispatch(professionalAction.getCrimeTitle());
    this.props.dispatch(professionalAction.getStatus());
    this.getCountry();
  }

  openUpdate = (values) => {
    const raw = String(values?.gender || "").toLowerCase();
    const selectedGender =
      raw === "f" || raw === "female"
        ? "female"
        : raw === "m" || raw === "male"
          ? "male"
          : values?.gender || undefined;
    this.setState({
      is_update: true,
      update_value: values,
      selectedGender,
    });
  };
  closeUpdate = () => {
    this.setState({
      is_update: false,
      update_value: null,
      selectedGender: undefined,
      updateLoading: false,
    });
  };

  getCctnsMissingList = () => {
    this.setState({
      loading: true,
    });

    superAdminService
      .CctnsMissingList({ city: this.state.cityId, type: this.state.type })
      .then((res) => {
        console.log("res", res);
        this.setState({
          data: res.results,
          loading: false,
        });
      });
  };

  getCityName = (id) => {
    const { pc_cities } = this.props && this.props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };
  downloadExcel = () => {
    const { t, language } = this.context;

    const report_name = "Cctns Missing Report";
    const file_name = `${report_name}_${moment().format("DDMMMYYYY")}`;

    let ReportTitle = "Cctns Missing Report";

    let list = [];
    const data = this.state.data;
    console.log("data", data);
    list =
      data &&
      data.map((data, index) => ({
        [t("sr.no")]: index + 1,
        ID: data.masterId,
        [t("accused_name")]: data.name,
        [t("accused_police_station")]: data.police_station,
        [t("incident_place")]: data.incident_place,
        [t("age")]: data.age,
      }));
    console.log("final list", list);

    var arrData = list;
    console.log("arrData", arrData);

    const ws = XLSX.utils.json_to_sheet(arrData, { origin: "A4" });

    const columnWidths = Object.keys(arrData[0]).map((key) => ({
      wch:
        Math.max(
          key.length,
          ...arrData.map((row) => String(row[key] || "").length),
        ) + 6,
    }));

    ws["!cols"] = columnWidths;

    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const subTitleStyle = {
      font: { bold: true, sz: 12, color: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const cellStyle = {
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    Object.keys(arrData[0]).forEach((_, colIndex) => {
      const cellRef = XLSX.utils.encode_cell({ r: 3, c: colIndex });
      if (ws[cellRef]) {
        ws[cellRef].s = headerStyle;
      }
    });

    arrData.forEach((row, rowIndex) => {
      Object.values(row).forEach((_, colIndex) => {
        const cellRef = XLSX.utils.encode_cell({
          r: rowIndex + 4,
          c: colIndex,
        });
        if (ws[cellRef]) {
          ws[cellRef].s = cellStyle;
        }
      });
    });

    console.log("this props.user", this.props.user);
    const cityName = this.getCityName(this.state.cityId[0]);
    console.log("cityName", cityName);
    const stateName =
      this.props?.user?.role === "2" && this.state.district_name;
    const headerData = `${cityName}`;

    ws["A1"] = { v: headerData, t: "s" };
    ws["A1"].s = titleStyle;

    ws["A2"] = { v: ReportTitle, t: "s" };
    ws["A2"].s = subTitleStyle;

    ws["A3"] = {
      v: `${
        moment(this.state.report_4_startDate).format("DD-MM-YYYY") || "-"
      } `,
      t: "s",
    };

    ws["A3"].s = subTitleStyle;

    const footerContent = `Generated At ${moment(new Date()).format(
      "DD MMM YYYY",
    )} From Criminal Monitoring Intelligent System`;

    const footerRowIndex = arrData.length + 6;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });
    ws[`A${footerRowIndex}`].s = {
      font: { italic: true, sz: 11, color: { rgb: "555555" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const mergeRanges = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: columnWidths.length - 1 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: columnWidths.length - 1 } },
      {
        s: { r: footerRowIndex - 1, c: 0 },
        e: { r: footerRowIndex - 1, c: columnWidths.length - 1 },
      },
      { s: { r: 2, c: 0 }, e: { r: 2, c: columnWidths.length - 1 } },
    ];

    ws["!merges"] = mergeRanges;

    ws["!rows"] = Array(footerRowIndex).fill({ hpt: 25 });
    ws["!rows"][footerRowIndex - 1] = { hpt: 40 };

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");

    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };

  handleTableChange = (pagination) => {
    this.setState({
      pagination: {
        ...this.state.pagination,
        current: pagination.current,
        pageSize: pagination.pageSize,
      },
    });
  };
  openImageModal = (img, name, id) => {
    this.setState({
      imageOpen: true,
      selectedImage: img,
      name: name,
      crime_id: id,
    });
  };

  closeImageModal = () => {
    this.setState({ imageOpen: false, selectedImage: null, name: null });
  };

  downloadFullPreview = () => {
    const imageKey = this.state.selectedImage;

    if (!imageKey) {
      console.error("No image selected");
      return;
    }

    const imageUrl =
      `https://cctns-missing-persons.s3.ap-south-1.amazonaws.com/` +
      imageKey.split("/").map(encodeURIComponent).join("/");

    const safeName = (this.state.name || "CMIS_Record")
      .replace(/[<>:"/\\|?*\x00-\x1F]/g, "_")
      .trim();

    const extension = imageKey.split(".").pop().split("?")[0];
    const fileName = `${safeName}.${extension}`;

    const link = document.createElement("a");
    link.href = imageUrl;
    link.download = fileName;

    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  render() {
    const { loading, searchText, pagination, data, cities } = this.state;
    const { professionals } = this.props;
    console.log("professional", professionals);
    const { t } = this.context;
    const columns = [
      {
        title: t("sr.no"),
        dataIndex: "srNo",
        key: "srNo",
        width: 80,
        render: (_, __, rowIndex) =>
          (pagination.current - 1) * pagination.pageSize + rowIndex + 1,
      },
      {
        title: t("date_of_missing"),
        dataIndex: "date_of_missing",
        key: "date_of_missing",
        width: 180,
        render: (text, record) => (
          <Space size="middle">
            {record?.date && moment(record.date).isValid()
              ? moment(record.date).format("DD-MM-YYYY")
              : "-"}
          </Space>
        ),
      },
      {
        title: t("missing_people"),
        dataIndex: "name",
        key: "name",
        width: 180,
        render: (text, record) => <Space size="middle">{record?.name}</Space>,
      },
      {
        title: t("accused_police_station"),
        dataIndex: "district",
        key: "district",
        width: 150,
        ellipsis: true,
        render: (text, record) => {
          const value = record.police_station
            ? `${record.police_station} - ${record.district}`
            : record.district;

          return (
            <Tooltip title={value}>
              <span>{value}</span>
            </Tooltip>
          );
        },
      },
      {
        title: t("incident_place"),
        dataIndex: "incident_place",
        key: "incident_place",
        width: 180,
      },
      {
        title: t("age"),
        dataIndex: "age",
        key: "age",
        width: 80,
      },
      {
        title: t("gender"),
        dataIndex: "gender",
        key: "gender",
        width: 100,
        render: (text, record) => (
          <Space>
            {record.gender === "male"
              ? t("male")
              : record.gender === "female"
                ? t("female")
                : "-"}
          </Space>
        ),
      },
      {
        title: t("photo"),
        key: "Photo",
        width: 100,
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {record.photo ? (
              <img
                style={{
                  width: 50,
                  height: 50,
                  objectFit: "cover",
                  cursor: "pointer",
                }}
                src={
                  "https://cctns-missing-persons.s3.ap-south-1.amazonaws.com/" +
                  record.photo
                }
                onClick={() =>
                  this.openImageModal(record.photo, record.name, record.id)
                }
                alt={record.name || "Photo"}
              />
            ) : (
              "नाही"
            )}
          </Space>
        ),
      },
      {
        title: t("action"),
        key: "action",
        width: 220,
        render: (text, record) => {
          const existingGender = String(record.gender || "").toLowerCase();

          return (
            <Radio.Group
              value={
                this.state.selectedGenders[record.id] ||
                (existingGender === "male" || existingGender === "female"
                  ? existingGender
                  : undefined)
              }
              onChange={(e) =>
                this.handleGenderChange(record.id, e.target.value)
              }
              className="gender-radio-group"
            >
              <Radio value="male" className="gender-radio">
                {t("male")}
              </Radio>

              <Radio value="female" className="gender-radio">
                {t("female")}
              </Radio>
            </Radio.Group>
          );
        },
      },
    ];
    return (
      <>
        <div
          className="site-page-header-ghost-wrapper"
          style={{
            padding: "20px",
            background: "#fff",
            marginBottom: "20px",
          }}
        >
          <PageHeader>CCTNS Missing-List</PageHeader>
          <div style={{ marginBottom: 16 }}>
            <Row
              gutter={[16, 16]}
              align="middle"
              style={{
                marginBottom: 16,
                width: "100%",
              }}
            >
              {/* State */}
              <Col>
                <Select
                  value={this.state.selected_state}
                  onChange={(value) => {
                    this.setState(
                      {
                        selected_state: value,
                        cityId: [],
                      },
                      () => {
                        if (value) {
                          this.getStatesWiseCityData(value);
                        }
                      },
                    );
                  }}
                  placeholder="Select State"
                  style={{ width: 250 }}
                  showSearch
                  allowClear
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option?.children
                      ?.toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  {this.state.states.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.state}
                    </Option>
                  ))}
                </Select>
              </Col>

              {/* City */}
              {this.state.selected_state && (
                <Col>
                  <Select
                    mode="multiple"
                    value={this.state.cityId}
                    onChange={(value) => this.setState({ cityId: value })}
                    placeholder="Select City"
                    style={{ width: 250 }}
                    showSearch
                    allowClear
                    optionFilterProp="children"
                    maxTagCount={2}
                    filterOption={(input, option) =>
                      option?.children
                        ?.toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {cities?.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.City}
                      </Option>
                    ))}
                  </Select>
                </Col>
              )}

              {/* Status */}
              <Col>
                <Radio.Group
                  value={this.state.type}
                  onChange={(e) => {
                    this.setState({
                      type: e.target.value,
                    });
                  }}
                  className="missing-status-radio"
                >
                  <Radio value="pending">Pending</Radio>
                  <Radio value="updated">Updated Data</Radio>
                </Radio.Group>
              </Col>

              {/* Find */}
              <Col>
                <Button
                  type="primary"
                  onClick={this.getCctnsMissingList}
                  disabled={!this.state.cityId?.length || !this.state.type}
                >
                  Find
                </Button>
              </Col>

              {/* Reset */}
              <Col>
                <Button
                  onClick={() =>
                    this.setState({
                      cityId: [],
                      data: [],
                      type: "pending",
                    })
                  }
                  disabled={
                    !this.state.cityId?.length &&
                    (!this.state.data || this.state.data.length === 0)
                  }
                >
                  Reset
                </Button>
              </Col>

              {/* Download Excel - Right Side */}
              <Col style={{ marginLeft: "auto" }}>
                <Button
                  type="primary"
                  onClick={this.downloadExcel}
                  disabled={!this.state.data?.length}
                >
                  Download Excel
                </Button>
              </Col>
            </Row>
          </div>

          <Row justify="end" style={{ marginBottom: 12 }}>
            <Col>
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 8,
                  padding: "6px 14px",
                  background: "#6f42c1",
                  borderRadius: 6,
                  boxShadow: "0 2px 6px rgba(111, 66, 193, 0.25)",
                }}
              >
                <span style={{ fontSize: 13, color: "#fff" }}>
                  {t("total")}:
                </span>
                <strong style={{ fontSize: 16, color: "#fff" }}>
                  {data.length}
                </strong>
              </div>
            </Col>
          </Row>

          <Row justify="end" style={{ marginBottom: 12 }}>
            <Button
              type="primary"
              loading={this.state.bulkUpdateLoading}
              disabled={Object.keys(this.state.selectedGenders).length === 0}
              onClick={this.handleBulkGenderUpdate}
            >
              Update Gender
            </Button>
          </Row>
          <Table
            bordered
            loading={loading}
            scroll={{ x: "max-content" }}
            columns={columns}
            dataSource={data}
            rowKey="id"
            rowClassName={() => "govt-table-row"}
            pagination={{
              ...pagination,
              total: data.length,
              showTotal: (total) => `Total ${total} states`,
            }}
            onChange={this.handleTableChange}
          />
          <Row justify="end" style={{ marginBottom: 12, marginTop: 12 }}>
            <Button
              type="primary"
              loading={this.state.bulkUpdateLoading}
              disabled={Object.keys(this.state.selectedGenders).length === 0}
              onClick={this.handleBulkGenderUpdate}
            >
              Update Gender
            </Button>
          </Row>

          {this.state.imageOpen && (
            <ImageViewOnly
              imageOpen={this.state.imageOpen}
              imageUrl={CCTNS_MISSING_IMAGE_URL + this.state.selectedImage}
              downloadName={this.state.name}
              onClose={this.closeImageModal}
            />
          )}
          <Modal
            title={t("gender")}
            visible={this.state.is_update}
            onCancel={this.closeUpdate}
            onOk={this.handleGenderUpdate}
            confirmLoading={this.state.updateLoading}
            okText="Update"
            destroyOnClose
            centered
            zIndex={2000}
            bodyStyle={{
              overflow: "visible",
              minHeight: 140,
              paddingBottom: 8,
            }}
          >
            <div style={{ marginBottom: 12 }}>
              <strong>{this.state.update_value?.name || "-"}</strong>
            </div>
            <div style={{ position: "relative", overflow: "visible" }}>
              <Select
                style={{ width: "100%" }}
                placeholder={t("gender")}
                value={this.state.selectedGender}
                onChange={(value) => this.setState({ selectedGender: value })}
                allowClear
                getPopupContainer={(trigger) => trigger.parentNode}
                dropdownStyle={{ zIndex: 2100 }}
                dropdownMatchSelectWidth
              >
                <Option value="male">{t("male")}</Option>
                <Option value="female">{t("female")}</Option>
              </Select>
            </div>
          </Modal>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}
const connectedCountryStates = connect(mapStateToProps)(CctnsMissingList);
export { connectedCountryStates as CctnsMissingList };
